import React from "react";
import { BemWithSpecifiContext } from "../../utils/bem";

export const MenuContext = React.createContext();
export const { Block, Elem } = BemWithSpecifiContext();
